module.exports = __webpack_public_path__ + "static/img/1-2.6ad5839.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/1-2.png
// module id = 3xqw
// module chunks = 0